import styled, {css} from 'styled-components'

export const StyledSuccessToastContent = styled.div(
    ({theme: {typography, palette}}) => css`
        display: flex;
        flex-direction: column;
        ${typography.textSm};

        & h3 {
            font-weight: 500;
            color: ${palette.neutral['950']};
        }
        & p {
            color: ${palette.neutral['600']};
        }
    `
)
